import { jsxs as l, jsx as a } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { W as s } from "./WaveLogo-BRI9e50e.js";
const c = 30, u = i(function({ size: e = c, showWordmark: o = !0, className: t, "aria-label": r }, n) {
  return /* @__PURE__ */ l(
    "div",
    {
      ref: n,
      "data-brand-lockup": !0,
      role: r ? "img" : void 0,
      "aria-label": r,
      className: ["ls-brand-lockup", t].filter(Boolean).join(" "),
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--space-2)",
        color: "var(--text-primary)"
      },
      children: [
        /* @__PURE__ */ a(s, { size: e, tone: "brand" }),
        o ? /* @__PURE__ */ a(
          "span",
          {
            "data-brand-lockup-wordmark": !0,
            style: {
              fontFamily: "var(--font-sans)",
              fontWeight: 700,
              fontSize: "var(--text-lg)",
              letterSpacing: 0,
              lineHeight: 1
            },
            children: "Barel"
          }
        ) : null
      ]
    }
  );
});
export {
  u as B
};
//# sourceMappingURL=BrandLockup-D1ZweBfr.js.map
